    <ng-container [formGroup]="detailForm">
        <mat-tab-group preserveContent
        [selectedIndex]="tabIndex"
        (selectedTabChange)="tabChanged($event)">
        <mat-tab>
            <ng-template mat-tab-label>
              {{ "fehmarn.overview-tab" | translate }}
            </ng-template>
            <ng-template matTabContent>
                    <app-chart-tab
                    id="printChart"
                    chartType="ColumnChart"
                    [currentlyActive]="this.tabIndex === 0 ? true : false"
                    [basicInfo]="this.data ? data : []"
                    stacked="false"
                    chartTitle="fehmarn.overview-chart-title"
                    style="overflow: hidden"
                    ></app-chart-tab>
                    <app-chart-tab
                    id="printChartLine"
                    chartType="LineChart"
                    [currentlyActive]="this.tabIndex === 0 ? true : false"
                    [basicInfo]="this.dataLine ? dataLine : []"
                    stacked="false"
                    chartTitle="fehmarn.line-chart-title"
                    style="overflow: hidden"
                    ></app-chart-tab>
                </ng-template>
                
        </mat-tab>
        
        </mat-tab-group>
      </ng-container>
      <button
          mat-raised-button
          (click)="print()"
          style="margin-left: 10px"
          type="button"
        >
          {{ "fehmarn.button_print" | translate }}
      </button>

  
  
